import { Check, X } from '@chain-zen/ui'

import type { TVisibilityAppSource } from '../../../types/tracking'
import { TrackingSourceRow } from '../tracking-source-row'
import { TrackingTimeDisplay } from '../tracking-time-display'
import { VisibilityProviderIcon } from './provider-icons/visibility-provider-icon'

interface IVisibilityAppInfoProps {
  shipmentID: string
  trackingSourceData: TVisibilityAppSource
}

/**
 * Displays the details for Visibility app
 */
export const VisibilityAppInfo = (props: IVisibilityAppInfoProps) => {
  const { trackingSourceData } = props

  const isTracking = trackingSourceData?.locations?.length ? true : false
  const StatusIcon = isTracking ? Check : X
  const statusIconColor = isTracking ? 'text-green-500 dark:text-green-400' : 'text-red-500 dark:text-red-400'
  const lastLocation =
    trackingSourceData?.locations && trackingSourceData.locations.length > 0
      ? trackingSourceData.locations[trackingSourceData.locations.length - 1]
      : null

  return (
    <TrackingSourceRow className="px-2">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1 flex-wrap">
          <StatusIcon className={`h-3 w-3 shrink-0 self-center ${statusIconColor}`} />
          <VisibilityProviderIcon provider={trackingSourceData?.metadata?.provider || null} size={3} />
          <span className="text-sm font-medium text-foreground">
            {trackingSourceData?.metadata?.provider || 'Visibility Provider'}
          </span>
          {!!lastLocation && (
            <TrackingTimeDisplay
              filterReason={trackingSourceData.filterReason}
              lastLocationCity={lastLocation.city}
              lastLocationFetchedAt={trackingSourceData.lastLocationFetchedAt}
              lastLocationStateCode={lastLocation.stateCode}
              lastLocationTimestamp={lastLocation.timestamp}
              wrapper="div"
              className="text-xs text-muted-foreground"
            />
          )}
        </div>

        <div className="flex items-center gap-1 text-xs text-muted-foreground flex-wrap">
          {!!trackingSourceData?.metadata?.deviceID && <span>Device ID: {trackingSourceData.metadata.deviceID}</span>}
        </div>
      </div>
    </TrackingSourceRow>
  )
}
